module.exports = __webpack_public_path__ + "static/media/solar-system.ca086ca6.svg";